/* eslint-disable import/prefer-default-export */
export const LoggingType = {
  MATCH: 'MATCH',
  PROFILE: 'PROFILE',
} as const;
